import { RequestResponse } from "../../DTO/requestResponse";
import { Request } from "../../CONSTANTS/request";
import { MICROSERVICIOS } from "../../CONSTANTS/constants";
import { RezagoOrdenFlete } from "./rezagoOrdenFlete.dto";
import { RezagoBulto } from "./rezagoBulto.dto";
import * as ONLY from "is-online";
import CheckVPN from "../../../SHARED/Check-VPN";

export default class Rezago {
  // Rezago.DatosRezagoOrdenFlete
  static async DatosRezagoOrdenFlete(
    rezago: RezagoOrdenFlete
  ): Promise<RequestResponse> {
    let direccion = "OdflCodigoRezago/Datos";

    if (await ONLY.default()) {
      if (await CheckVPN()) {
        // if (true) {
        return new Request(MICROSERVICIOS.CONSULTA_TOPDESK).postTopDesk(
          direccion,
          rezago
        );
      } else {
        return {
          status: -2,
          description:
            "No fue posible obtener información, No hay conexión con VPN",
          data: null,
          error: "No fue posible obtener información, No hay conexion con VPN",
        };
      }
    } else {
      return {
        status: -1,
        description:
          "No fue posible obtener información, No hay conexión a Internet",
        data: null,
        error: "No fue posible obtener información, No hay conexion a Internet",
      };
    }
  } // final funcion DatosRezagoOrdenFlete

  // Rezago.DatosRezagoBulto
  static async DatosRezagoBulto(rezago: RezagoBulto): Promise<RequestResponse> {
    let direccion = "BultoCodigoRezago/Datos";

    if (await ONLY.default()) {
      if (await CheckVPN()) {
        // if (true) {
        return new Request(MICROSERVICIOS.CONSULTA_TOPDESK).postTopDesk(
          direccion,
          rezago
        );
      } else {
        return {
          status: -2,
          description:
            "No fue posible obtener información, No hay conexión con VPN",
          data: null,
          error: "No fue posible obtener información, No hay conexion con VPN",
        };
      }
    } else {
      return {
        status: -1,
        description:
          "No fue posible obtener información, No hay conexión a Internet",
        data: null,
        error: "No fue posible obtener información, No hay conexion a Internet",
      };
    }
  } // final funcion DatosRezagoBulto
} // final clase
